import { useNavigate } from 'react-router-dom';
import { useApp } from '../../contexts/AppContext';
import { DEPT_DB_MAP, DEPARTMENTS, formatAmount } from '../../constants';

export default function ByDepartmentTab() {
  const { filteredExceptions: allExceptions, loading } = useApp();
  const navigate = useNavigate();

  if (loading) return <div style={{ textAlign: 'center', padding: 80, color: 'var(--text-secondary)' }}>Loading...</div>;

  // Group by display department
  const byDept: Record<string, { total: number; flagged: number; escalated: number; resolved: number; exposure: number }> = {};
  for (const exc of allExceptions) {
    const dept = DEPT_DB_MAP[exc.department] || exc.department;
    if (!byDept[dept]) byDept[dept] = { total: 0, flagged: 0, escalated: 0, resolved: 0, exposure: 0 };
    byDept[dept].total++;
    const st = (exc.status || '').toLowerCase();
    if (st === 'flagged') byDept[dept].flagged++;
    if (st === 'escalated') byDept[dept].escalated++;
    if (st.startsWith('resolved')) byDept[dept].resolved++;
    byDept[dept].exposure += exc.amount || 0;
  }

  const sorted = Object.entries(byDept).sort((a, b) => b[1].exposure - a[1].exposure);

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 14 }}>
        {sorted.map(([dept, data]) => {
          const color = DEPARTMENTS[dept]?.color || 'var(--text-tertiary)';
          const resolvedPct = data.total > 0 ? Math.round((data.resolved / data.total) * 100) : 0;
          return (
            <div
              key={dept}
              className="card card-click"
              style={{ padding: '18px 20px', border: '1px solid var(--border-subtle)', borderRadius: 8, cursor: 'pointer', background: 'var(--bg-card)' }}
              onClick={() => navigate(`/exception-tracker?dept=${encodeURIComponent(dept)}`)}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 700 }}>{dept}</div>
                  <div style={{ fontSize: 11, color: 'var(--text-secondary)' }}>{data.total} exceptions</div>
                </div>
                <div className="mono" style={{ fontSize: 16, fontWeight: 700, color: 'var(--amber)' }}>
                  {formatAmount(data.exposure)}
                </div>
              </div>
              {/* Mini bar */}
              <div style={{ height: 5, background: 'var(--bg-elevated)', borderRadius: 3, overflow: 'hidden', marginBottom: 10 }}>
                <div style={{ height: '100%', width: `${resolvedPct}%`, background: 'var(--green)', borderRadius: 3 }} />
              </div>
              <div style={{ display: 'flex', gap: 16, fontSize: 10, color: 'var(--text-tertiary)' }}>
                <span><span style={{ color: 'var(--amber)', fontWeight: 700 }}>{data.flagged}</span> flagged</span>
                <span><span style={{ color: 'var(--red)', fontWeight: 700 }}>{data.escalated}</span> escalated</span>
                <span><span style={{ color: 'var(--green)', fontWeight: 700 }}>{data.resolved}</span> resolved</span>
                <span style={{ marginLeft: 'auto' }}>{resolvedPct}% resolved</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
